module.exports = __webpack_public_path__ + "img/firefox.f824ef9b.png";